import { useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { LangContext } from "../../context/LangContext";
import { openLangSelector } from "../../redux";
import { FaChevronDown } from "react-icons/fa";

import "./style.css"

import flag_fr from '../../assets/svg/flag_fr.svg'
import flag_en from '../../assets/svg/flag_en.svg'

function Lang() {
    const dispath = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    const { language } = useContext(LangContext);

    const isOpen = useSelector(state => state.options.langSelectorIsOpen);
    const headerHeight = useSelector(state => state.options.headerHeight);

    const select_lang = (newLang) => {
        if (!isOpen) {
            dispath(openLangSelector(true));
            return;
        }

        const segments = location.pathname.split('/');
        segments[1] = newLang; // remplace la langue
        navigate(segments.join('/'));

        dispath(openLangSelector(false));
    };

    return (
        <div className="lang_switcher" style={{ top: `calc(${headerHeight}px + 21px)` }}>
            <div className={isOpen ? 'isOpen' : ''}>
                <button onClick={() => select_lang(language)}>
                    <FaChevronDown />
                    <p>{language === 'fr' ? 'Français' : 'English'}</p>
                    <img src={language === 'fr' ? flag_fr : flag_en} alt="" />
                </button>

                <button onClick={() => select_lang(language === 'fr' ? 'en' : 'fr')}>
                    <p>{language === 'fr' ? 'English' : 'Français'}</p>
                    <img src={language === 'fr' ? flag_en : flag_fr} alt="" />
                </button>
            </div>
        </div>
    )
}

export default Lang;